import { trustedRequest } from 'utils/request';

export const getProductById = (id: number) => trustedRequest(`/api/products/${id}`);

export const getProductsByCategory = (categoryId: number, productId: number) => trustedRequest(`/api/products/category/${categoryId}/product/${productId}`);
